<ng-template [ngIf]="form">
	<div>
		<div class="col-sm-12 coldx">
			<h4 *ngIf="title">{{title}}</h4>
			<form [formGroup]="form" (ngSubmit)="update();">
				<div class="row">
					<div textInput class="col-sm-6"
					[labelInput]="'Nominativo/Rag. Sociale del Terzo pignorato'"
					formControlName="terzo"
					[(ngModel)]="request.terzo"
					[mandatory]="true"></div>


					<div textInput class="col-sm-6" [labelInput]="'Codice Fiscale/P.Iva'"
					formControlName="cf"
					[(ngModel)]="request.cf"></div>


				</div>

				<div class="row">
					<div textInput class="col-sm-6" [labelInput]="'Sede legale'"
					formControlName="sede"
					[(ngModel)]="request.sede"></div>
					<div textInput class="col-sm-6" [labelInput]="'PEC'"
					formControlName="pec"
					[(ngModel)]="request.pec"></div>
				</div>

				<div class="row">
					<div textInputCurrency class="col-sm-4" [control]="form.controls['importoPrecettato']"
						[labelInput]="'Importo precettato'" [location]="'SezioneEconomica'" [mandatory]="true"
						formControlName="importoPrecettato" [(ngModel)]="request.importoPrecettato"></div>

					<div class="form-group col-sm-4">
						<label for="selectPignorato">Esito</label>
            <span class="mandatory">*</span>
						<select
							[(ngModel)]="request.pignorato" name="pignorato" formControlName="pignorato"
							class="form-control" id="selectPignorato" [value]="request.pignorato" required>
							<option value="">Seleziona esito</option>
							<option value="true">Positivo</option>
							<option value="false">Negativo</option>
						</select>
					</div>

					<div textInputCurrency class="col-sm-4" [control]="form.controls['sommaPignorata']"
					[labelInput]="'Somma pignorata'" [location]="'SezioneEconomica'"
					formControlName="sommaPignorata" [(ngModel)]="request.sommaPignorata"
					[submitPending]="!request.pignorato"></div>

				</div>

				<div class="row">
					<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
						formControlName="note" [(ngModel)]="request.note"></div>
				</div>

				<div class="row">
					<p class="mandatory col-sm-12">
						<em>* Campi obbligatori</em>
					</p>
				</div>

				<div class="row">
					<p class="col-sm-3 col-xs-6">
						<button type="button" class="btn btn-outline-secondary btn-block"
							(click)="createForm();">Reset</button>
					</p>
					<p submitButton
						class="col-sm-3 col-xs-6 col-sm-offset-6"
						[labelButton]="'Salva'" [disabled]='!form.valid'>
				</div>
			</form>
		</div>
	</div>
	</ng-template>
